import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { KeyboardDatePicker } from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import ICInput from "../../components/form/input";
import APP_CONSTANTS from "../../constants";
import MakeAPICall from "../../apiCalls/common";
import {
    generateEPrescribingApiRoute,
  getTraditionalPrescriptionListAPI,
  getTraditionalPrescriptionListWithFilterAPI,
  hideTraditionalPrescriptionFromAdminAPI,
    sendCustomNoteApiRoute,
  updateTraditionalPrescriptionConsultNote
} from "../../apiRoutes";
import { sortData, csUndefined } from "../../utils/commonMethods";

import CustomModal from "../../components/modal";
import Loader from "../../components/loader";
import CustomDataTable from "../../components/datatable/customDataTableSearchByFilter";

import Label from "../../components/label";
import moment from "moment";
import searchFilterList from "../../constants/searchFilterList";
import { updateUnreadErxOfflineCount } from "../../reduxStore/actions/serverConstants";
import PatientProfileForm from "../../containers/PatientsForms/patientProfileForm";
import { STATE_LIST } from "../../constants/constants";
import ICNoImg from "../../assets/images/default-picture.png";
import { converToUtc, getFormattedDate, getFormattedTime } from "../../utils/dateTimeHelper";

const TraditionalPrescriptionListPage = (props) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [apiCallParams, setApiCallParams] = useState(null);
    const [prescriptionList, setPrescriptionList] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currFilters, setCurrFilters] = useState({
        skip: 0,
        limit: 10,
        startDate: '',
        endDate: ''
    });
    const [showTextModal, setShowTextModal] = useState(false);
    const [modalText, setModalText] = useState("");
    const [showTextModalTitle, setShowTextModalTitle] = useState("");

    const [showPatientIHIError, setShowPatientIHIError] = useState(false);

    const [selectedConsultNote, setSelectedConsultNote] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const [filterStatus, setFilterStatus] = useState('');

    const [showProfileModal, setShowProfileModal] = useState(false);
    const [currSelPat, setCurrSelPat] = useState(null);

    const [showePrescriptionSentSuccessModal, setShowePrescriptionSentSuccessModal] = useState(false);

    const tableHeaders = [
        {
            key: "patientId",
            value: "UIN"
        },
        { key: "patientDetails", value: "Patient Details" },
        { key: "doctorDetails", value: "Doctor Details" },
        // { key: "pharmacyDetails", value: "Pharmacy Details" },
        { key: "status", value: "Status" },
        // { key: "Pharmacist Name", value: "Pharmacist Name" },
        { key: "notes", value: "Notes" },
        { key: "Action", value: "Action" }
    ];


    // const setTableFilters = filters => {
    //     let newFilter = Object.assign({}, currFilters);
    //     newFilter.limit = filters.limit;
    //     newFilter.skip = filters.skip;
    //     newFilter.text = filters.text;
    //     setCurrFilters(newFilter);
    // };

    const setTableFilters = filters => {
        let newFilter = Object.assign({}, currFilters);
        newFilter.limit = filters.limit;
        newFilter.skip = filters.skip;
        newFilter.text = filters.text;
        newFilter.filterType = filters.filterType;
        newFilter.status = filterStatus;
        setCurrFilters(newFilter);
    };

    const sortTableDataByColumn = SelColumn => {
        let sortedData = sortData(
            SelColumn.column,
            SelColumn.order,
            prescriptionList
        );
        setPrescriptionList(sortedData);
    };

    const arrangePatientDataForForm = (column) => {
        let d = {};
        if (!column) {
            return false;
        }

        d._id = column._id;
        if (column.patientId) {
            d.patientId = column.patientId;
        } else {
            d.patientId = "";
        }
        d.gender = column.gender;
        d.profilePicOri =
            column.profilePic === null ||
                column.profilePic === undefined ||
                column.profilePic === ""
                ? ICNoImg
                : column.profilePic.original;
        d.refNumerOnMedicareCard = column.refNumerOnMedicareCard;
        d.medicareNumber = column.medicareNumber;
        d.postCode = column.address.postCode;
        d.state = column.address.state;
        d.suburb = column.address.suburb;
        d.streetName = column.address.streetName;
        d.streetNumber =
            column.address.unitNumber === null ||
                column.address.unitNumber === undefined ||
                column.address.unitNumber === ""
                ? column.address.streetNumber
                : column.address.unitNumber + "/" + column.address.streetNumber;
        d.unitNumber =
            column.unitNumber !== null ||
                column.unitNumber !== "undefined" ||
                column.unitNumber !== ""
                ? ""
                : column.unitNumber;

        d.phoneNumber = column.phoneNumber || "";
        d.dateOfBirth = column.dateOfBirth;
        d.email = column.email;
        d.lastName = column.lastName;
        d.middleName =
            column.middleName === null ||
                column.middleName === undefined ||
                column.middleName === ""
                ? ""
                : column.middleName;
        d.firstName = column.firstName;
        d.firstNameForHIService = column.firstNameForHIService;
        d.lastNameForHIService = column.lastNameForHIService;

        d.fullName = column.firstName + " ";

        if (
            column.middleName !== null &&
            column.middleName !== undefined &&
            column.middleName !== ""
        ) {
            d.fullName = d.fullName + column.middleName + " ";
        }

        d.fullName = d.fullName + column.lastName;

        if (column.kin1) {
            d.contactName =
                column.kin1.name === "" ||
                    column.kin1.name === null ||
                    column.kin1.name === undefined
                    ? ""
                    : column.kin1.name;
            if (
                column.kin1.contact === "" ||
                column.kin1.contact === null ||
                column.kin1.contact === undefined
            ) {
                d.contactContact = "";
            } else {
                d.contactContact = column.kin1.contact;
            }
        } else {
            d.contactName = "";
            d.contactContact = "";
        }
        if (column.kin2) {
            d.contactName2 =
                column.kin2.name === "" ||
                    column.kin2.name === null ||
                    column.kin2.name === undefined
                    ? ""
                    : column.kin2.name;
            if (
                column.kin2.contact === "" ||
                column.kin2.contact === null ||
                column.kin2.contact === undefined
            ) {
                d.contactContact2 = "";
            } else {
                d.contactContact2 = column.kin2.contact;
            }
        } else {
            d.contactName2 = "";
            d.contactContact2 = "";
        }
        if (column.additionalInfo) {
            d.additionalInfo = column.additionalInfo;
        } else {
            d.additionalInfo = " ";
        }
        d.isBlocked = column.isBlocked;
        d.registrationDate =
            csUndefined(getFormattedDate(column.createdAt)) +
            " " +
            csUndefined(getFormattedTime(column.createdAt));

        if (
            column.patientCards &&
            column.patientCards !== undefined &&
            column.patientCards !== null
        ) {
            if (Array.isArray(column.patientCards) === true) {
                if (
                    column.patientCards.length > 0 &&
                    column.patientCards[0] !== null &&
                    column.patientCards[0] !== undefined
                ) {
                    d.patientCards = column.patientCards;
                } else {
                    d.patientCards = [];
                }
            } else if (column.patientCards.lastFourDigit) {
                d.patientCards = [column.patientCards];
            } else {
                d.patientCards = [];
            }
        } else {
            d.patientCards = [];
        }

        d.verificationByMedicareOnlineCode =
            column.verificationByMedicareOnlineCode;
        d.verificationByMedicareOnlineUpdatedAt =
            column.verificationByMedicareOnlineUpdatedAt;
        d.IHIInfo = column.IHIInfo;
        d.optOutMarketingEmails =
            column.optOutMarketingEmails === true ? true : false;
        // d.DVANumber = column.DVANumber;

        d.isDependent = column.isDependent === true ? true : false;
        d.dependents = column.dependents ? column.dependents : [];
        d.parentId = column.parentId ? column.parentId : null;

        d.isInstantSwitchOnly = column.isInstantSwitchOnly || false;
        d.isPatientRequestToDeleteAC = column.isPatientRequestToDeleteAC || false;

        return d;
    }

    // get pharmacies list
    const getPrescriptionList = () => {
        setIsProcessing(true);
        console.log("Current Filters: ", currFilters);
        let searchAPI = getTraditionalPrescriptionListAPI;
        if (currFilters && currFilters.text && currFilters.filterType && currFilters.text.trim() != "" && currFilters.filterType !== "") {
            searchAPI = getTraditionalPrescriptionListWithFilterAPI;
        }

        setApiCallParams({
            reqType: "GET",
            reqUrl: searchAPI,
            params: currFilters,
            successCallback: async res => {
                console.log("Got the response for traditional prescription: ", res.data);
                let list = [];
                await res.data.data.getData.forEach((value, index) => {
                    let rowColor = "";
                    if (value.status === "Open") {
                        if (value.isInstantSwitch) {
                            rowColor = "is-row";
                        } else if (value.isInstantSwitchMC) {
                            rowColor = "is-mc-row";
                        } else if (value.inInstantHush) {
                            rowColor = "ih-row";
                        } else {
                            rowColor = "ic-row";
                        }
                    } else if (value.status === "Doctor to Call") {
                        rowColor = "pink-row";
                    }

                    let docPhoneNo = '';
                    let patientPhoneNo = '';
                    let pharmacyPhoneNo = '';

                    if (value.doctorId && value.doctorId.phoneNumber) {
                        let ph = value.doctorId.phoneNumber.replace(/\s/g, '');
                        docPhoneNo = ph.slice(0, 4) + " " + ph.slice(4, 7) + " " + ph.slice(7, 10);
                    }

                    if (value.patientId && value.patientId.phoneNumber) {
                        let ph2 = value.patientId.phoneNumber.replace(/\s/g, '');
                        patientPhoneNo = ph2.slice(0, 4) + " " + ph2.slice(4, 7) + " " + ph2.slice(7, 10);
                    }

                    if (value.urlObjectId && value.urlObjectId.pharmacyNumber) {
                        pharmacyPhoneNo = value.urlObjectId.pharmacyNumber;
                    }

                    let uinColor = '';

                    if (value.isERXOffline) {
                        uinColor = 'red-text';
                    }

                    if (value.isPharmacySelectLinkSent || value.isInvalidIHIInformedToPatient) {
                        uinColor = 'green-text'
                    }

                    if (value.isSupportRequiredByPatient) {
                        uinColor = 'pink-text'
                    }

                    // if (!value.patientSelectPharmacyLink) {
                    //     uinColor = 'red-text';
                    // }

                    if (value.isPharmacySelectLinkSent && value.status === "Completed" || value.isInvalidIHIInformedToPatient) {
                        uinColor = 'green-text';
                    }

                    // when doctor generates the prescription and try to send to patient and it fails then support will notify with UIN grey color
                    if (!value.isPharmacySetByPatient && !value.isPharmacySelectLinkSent && !value.isSupportRequiredByPatient && !value.isERXOffline && !value.isInvalidIHIInformedToPatient) {
                        uinColor = '';
                    }

                    const formedPatientData = arrangePatientDataForForm(value.patientId);

                    if (value.patientId && value.doctorId) {
                        list.push({
                            "_id": value._id,
                            "patientId": value.patientId.patientId,
                            "doctorDetails": {
                                "name": value.doctorId.firstName + ' ' + value.doctorId.lastName,
                                "doctorId": value.doctorId.doctorId,
                                "phoneNumber": docPhoneNo,
                                "email": value.doctorId.email,
                                "_id": value.doctorId._id,
                            },
                            "patientDetails": {
                                "name": value.patientId.firstName + ' ' + value.patientId.lastName,
                                "phoneNumber": patientPhoneNo,
                                "email": value.patientId.email,
                                "_id": value.patientId._id
                            },
                            "patientData": formedPatientData,
                            "pharmacyDetails": {
                                "name": value.urlObjectId && value.urlObjectId.pharmacyName ? value.urlObjectId.pharmacyName : '',
                                "email": value.urlObjectId && value.urlObjectId.pharmacyEmail ? value.urlObjectId.pharmacyEmail : '',
                                "phoneNumber": pharmacyPhoneNo,
                                "pharmacyAddress1": value.urlObjectId && value.urlObjectId.pharmacyAddress1 ? value.urlObjectId.pharmacyAddress1 : '',
                                "pharmacyAddress2": value.urlObjectId && value.urlObjectId.pharmacyAddress2 ? value.urlObjectId.pharmacyAddress2 : '',
                                "pharmacyAddress3": value.urlObjectId && value.urlObjectId.pharmacyAddress3 ? value.urlObjectId.pharmacyAddress3 : '',
                            },
                            "status": value.status,
                            "pharmacistName": value.pharmacistName,
                            "rowColor": rowColor,
                            "isSupportRequiredByPatient": value.isSupportRequiredByPatient,
                            "isPharmacySelectLinkSent": value.isPharmacySelectLinkSent,
                            'uinColor': uinColor,
                            "prescriptionURL": value.prescriptionURL,
                            "isInstantSwitch": value.isInstantSwitch || false,
                            "isInstantSwitchMC": value.isInstantSwitchMC || false,
                            "inInstantHush": value.inInstantHush || false,
                            "notes": value.notes
                        });
                    }
                })
                setPrescriptionList(list);
                setTotalRecords(res.data.data.getCount);
                setIsProcessing(false);

                props.updateUnreadErxOfflineCount(res.data.data.openTraditionlPrescriptionCount);
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowTextModal(true);
            }
        });
    };


    useEffect(() => {
        getPrescriptionList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currFilters]);

    const handleStartDateChange = date => {
        setStartDate(date);
    };

    const handleEndDateChange = date => {
        setEndDate(date);
    };

    const clearFilter = () => {
        setStartDate(null);
        setEndDate(null);
    };

    const saveDetails = (consultNoteData) => {
        console.log("Now saving details: ", consultNoteData);
        const dataToSend = {
            consultNoteId: consultNoteData["_id"],
            status: consultNoteData["status"],
            pharmacistName: consultNoteData["pharmacistName"],
            notes: consultNoteData["notes"],
        };
        updateData(dataToSend);
    }

    const handleChangeStatus = (newStatus, index) => {
        let copyData = [...prescriptionList];
        copyData[index]['status'] = newStatus;
        setPrescriptionList(copyData);
    }

    const handlePharmacistChangeInput = (value, index) => {
        let copyData = [...prescriptionList];
        copyData[index]['pharmacistName'] = value;
        setPrescriptionList(copyData);
    }

    const handleNoteChangeInput = (value, index) => {
        let copyData = [...prescriptionList];
        copyData[index]['notes'] = value;
        setPrescriptionList(copyData);
    }

    const hideTraditionalPrescription = (consultNoteData) => {
        const dataToSend = {
            consultNoteId: consultNoteData._id
        };

        setIsProcessing(true);

        setApiCallParams({
            reqType: "PUT",
            reqUrl: hideTraditionalPrescriptionFromAdminAPI,
            dataObj: dataToSend,
            successCallback: async res => {
                getPrescriptionList();
                setIsProcessing(false);
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowTextModal(true);
            }
        });
    }

    const deleteTraditionalPrescription = () => {
        setShowDeletePopup(false);
        hideTraditionalPrescription(selectedConsultNote);
    }

    const openConfirmDeletPopUp = (consultNoteData) => {
        setSelectedConsultNote(consultNoteData);
        setShowDeletePopup(true);
    }
    const updateData = (dataToSend) => {
        setIsProcessing(true);

        setApiCallParams({
            reqType: "PUT",
            reqUrl: updateTraditionalPrescriptionConsultNote,
            dataObj: dataToSend,
            successCallback: async res => {
                getPrescriptionList();
                setIsProcessing(false);
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowTextModal(true);
            }
        });
    }

    const handleSearchByDate = () => {
        let newFilter = Object.assign({}, currFilters);
        newFilter.skip = 0;
        newFilter.startDate = moment(startDate).startOf("day").toISOString();
        newFilter.endDate = moment(endDate).endOf("day").toISOString();
        newFilter.status = filterStatus;
        setCurrFilters(newFilter);
    }

    const handleFilterByStatus = (status) => {
        setFilterStatus(status);
        let newFilter = Object.assign({}, currFilters);
        newFilter.skip = 0;
        newFilter.startDate = moment(startDate).startOf("day").toISOString();
        newFilter.endDate = moment(endDate).endOf("day").toISOString();
        newFilter.status = status;
        setCurrFilters(newFilter);

    }

    const openPMS = (patientId) => {
        const auth = props.auth.user;
        window.open(
            APP_CONSTANTS.pmsURL +
            "/patient/patientDetails?accessToken=" +
            auth.accessToken +
            "&patientId=" +
            patientId +
            "&searchType=" +
            auth.userType +
            "&adminName=" +
            auth.firstName +
            " " +
            auth.lastName,
            "_blank"
        );
    };

    const sendCustomEPrescriptionNote = (formDataToSend) => {
        setIsProcessing(true);
        let apiParams = {
            reqType: "PUT",
            reqUrl: sendCustomNoteApiRoute,
            dataObj: formDataToSend,
            successCallback: async res => {
                setIsProcessing(false);
                setShowePrescriptionSentSuccessModal(true);
            },
            failureCallback: err => {
                setIsProcessing(false);
            }
        };

        setApiCallParams(apiParams);
    }

    const redoEPrescription = (item, index) => {

        setCurrSelPat(item.patientData);

        setIsProcessing(true);
        console.log("User wants to redo for this ePresc: ", item);
        let formData = new FormData();
        formData.append("url", item.prescriptionURL);
        formData.append("doctorObjectID", item.doctorDetails._id);
        formData.append("patientObjectID", item.patientDetails._id);

        // means we are trying to do ePrescription again and not trying to generate erx offline thing just yet
        formData.append("redoEPres", true);

        let apiParams = {
            reqType: "POST",
            reqUrl: generateEPrescribingApiRoute,
            dataObj: formData,
            successCallback: async res => {
                setIsProcessing(false);

                console.log("redoEPrescription: ", res);
                let customNoteEPresFormData = new FormData();
                customNoteEPresFormData.append("url", item.prescriptionURL);
                customNoteEPresFormData.append(
                    "tokenSendingMethod",
                    res.data.tokenSendingMethod
                );
                customNoteEPresFormData.append("isInstantSwitch", item.isInstantSwitch);
                customNoteEPresFormData.append("isInstantHush", item.inInstantHush);
                sendCustomEPrescriptionNote(customNoteEPresFormData);

                let tempList = [...prescriptionList];
                tempList.splice(index, 1);
                setPrescriptionList(tempList);

                const actionIHICount = props.serverConstants && props.serverConstants.unreadErxOfflineCount && props.serverConstants.unreadErxOfflineCount > 0 ? (props.serverConstants.unreadErxOfflineCount - 1) : 0;
                props.updateUnreadErxOfflineCount(actionIHICount);
            },
            failureCallback: err => {
                setIsProcessing(false);
                console.log("Err: ", err, err.message);
                if (err && err.message && err.message.toLowerCase().includes("invalid ihi")) {
                    setShowPatientIHIError(true);
                } else if (err && err.message) {
                    setShowTextModalTitle("Error");
                    setModalText(
                        err.message
                    );
                    setShowTextModal(true);
                } else {
                    setShowTextModalTitle("Error");
                    setModalText(
                        'Something went wrong. Please try again'
                    );
                    setShowTextModal(true);
                }
                getPrescriptionList();
            },
            showErrPopup: false
        };

        setApiCallParams(apiParams);
    }

    const patEditSuccess = () => {
        setShowProfileModal(false);
        setModalText("Patient's Profile Updated Successfully");
        setShowTextModal(true);
    };

    return (
        <div className="view-ticket-container prescription-list">
            <CustomModal
                useOneButton={true}
                cancelText="OKAY"
                openModal={showTextModal}
                cancelEvent={() => {
                    setShowTextModal(false);
                    setModalText("");
                    setShowTextModalTitle("");
                }}
                title={showTextModalTitle}
                modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
            />
            <CustomModal
                cancelText="Okay"
                openModal={showPatientIHIError}
                cancelEvent={() => {
                    setShowPatientIHIError(false);
                }}
                title={'Invalid IHI'}
                modalBodyContent={<p className="text-center mb-0">Validate the patient's IHI prior to attempting to resend the prescription again</p>}
                okayText={'Open Patient Profile'}
                okayEvent={() => {
                    setShowPatientIHIError(false);
                    setShowProfileModal(true);
                }}
            />
            <CustomModal
                className="modal-lg"
                openModal={showProfileModal}
                cancelEvent={() => {
                    setShowProfileModal(false);
                    setCurrSelPat(null);
                }}
                title={<span>Patient Profile</span>}
                modalBodyContent={
                    <PatientProfileForm
                        statesList={STATE_LIST}
                        data={currSelPat}
                        successEvent={patEditSuccess}
                    />
                }
                noFooterButtons={true}
                backdrop="static"
            />
            <CustomModal
                cancelText="Cancel"
                openModal={showePrescriptionSentSuccessModal}
                cancelEvent={() => {
                    setShowePrescriptionSentSuccessModal(false);
                }}
                okayText={'Open Patient Record'}
                okayEvent={() => {
                    setShowePrescriptionSentSuccessModal(false);
                    openPMS(currSelPat._id);
                }}
                title={'ePrescription Successfully Sent'}
                modalBodyContent={<p className="text-center mb-0">Ensure to check patient record for other prescriptions or documents requiring sending to patient</p>}
            />
            {isProcessing && <Loader />}
            <div className={isProcessing ? "disableContainer" : ""}>
                <div className="d-flex flex-row flex-wrap justify-content-between">
                    <h3>Action Invalid IHI</h3>
                    <div className="d-flex flex-row align-items-end">
                        <TextField
                            select
                            SelectProps={{
                                native: true
                            }}
                            onChange={e => handleFilterByStatus(e.target.value)}
                            className="mr-4"
                        >
                            <option value="">Select Status</option>
                            <option value="Open">Open</option>
                            <option value="Notified">Notified</option>
                            {/* <option value="Doctor to Call">Doctor to Call</option> */}
                            <option value="Completed">Completed</option>
                        </TextField>
                        <KeyboardDatePicker
                            name="startDate"
                            style={{ width: "135px" }}
                            autoOk
                            variant="inline"
                            mask="__-__-____"
                            format="DD-MM-YYYY"
                            label="Start Date"
                            value={startDate}
                            onChange={date => handleStartDateChange(date)}
                        />
                        <KeyboardDatePicker
                            name="endDate"
                            style={{ width: "135px", marginLeft: "20px" }}
                            autoOk
                            variant="inline"
                            mask="__-__-____"
                            format="DD-MM-YYYY"
                            label="End Date"
                            value={endDate}
                            onChange={date => handleEndDateChange(date)}
                        />

                        <button
                            style={{ minWidth: "30px", width: "30px" }}
                            className="insta-button-primary ml-3"
                            onClick={handleSearchByDate}
                        >
                            <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <CustomDataTable
                    totalRecords={totalRecords}
                    headers={tableHeaders}
                    setFilters={setTableFilters}
                    sortData={sortTableDataByColumn}
                    tabFilters={currFilters}
                    searchFilterList={searchFilterList.traditionalPrescriptionFilterList}
                >
                    {prescriptionList.map((item, index) => (
                        <tr key={index} className={item.rowColor}>
                            <td className="cursor-pointer" onClick={() => openPMS(item.patientDetails._id)}><Label title={item.patientId} className={`w-auto font-12 mb-0 secondary-font cursor-pointer ${item.uinColor}`}></Label></td>
                            <td>
                                <Label title={item.patientDetails.name} className="w-auto font-12 mb-0 secondary-font"></Label> <br />
                                <Label title={item.patientDetails.email} className="w-auto font-12 mb-0"></Label> <br />
                                <Label title={item.patientDetails.phoneNumber} className="w-auto font-12 mb-0"></Label>
                            </td>
                            <td>
                                <Label title={item.doctorDetails.name} className="w-auto font-12 mb-0 secondary-font"></Label> <br />
                                <Label title={item.doctorDetails.email} className="w-auto font-12 mb-0"></Label> <br />
                                <Label title={item.doctorDetails.phoneNumber} className="w-auto font-12 mb-0"></Label>
                            </td>
                            {/* <td>
                                {
                                    (item.pharmacyDetails.name && item.pharmacyDetails.email && item.pharmacyDetails.phoneNumber) ? (
                                        <Fragment>
                                            <Label title={item.pharmacyDetails.name} className="w-auto font-12 mb-0 secondary-font"></Label> <br />
                                            <Label title={item.pharmacyDetails.email} className="w-auto font-12 mb-0"></Label> <br />
                                            <Label title={item.pharmacyDetails.phoneNumber} className="w-auto font-12 mb-0"></Label><br />
                                        </Fragment>
                                    ) : ('-')
                                }
                                {
                                    item.pharmacyDetails.pharmacyAddress1 && (
                                        <Fragment>
                                            <Label title={item.pharmacyDetails.pharmacyAddress1} className="mb-0 font-12"></Label><br />
                                        </Fragment>
                                    )
                                }
                                {
                                    item.pharmacyDetails.pharmacyAddress2 && (
                                        <Fragment>
                                            <Label title={item.pharmacyDetails.pharmacyAddress2} className="mb-0 font-12"></Label><br />
                                        </Fragment>
                                    )
                                }
                                {
                                    item.pharmacyDetails.pharmacyAddress3 && (
                                        <Fragment>
                                            <Label title={item.pharmacyDetails.pharmacyAddress3} className="mb-0 font-12"></Label><br />
                                        </Fragment>
                                    )
                                }
                            </td> */}
                            <td>
                                <TextField
                                    name={"gender" + index}
                                    className="w-100 font-12"
                                    select
                                    value={item.status}
                                    SelectProps={{
                                        native: true
                                    }}
                                    onChange={(event) => {
                                        handleChangeStatus(event.target.value, index);
                                    }}
                                >
                                    <option>Select Status</option>
                                    <option value="Open">Open</option>
                                    <option value="Notified">Notified</option>
                                    {/* <option value="Doctor to Call">Doctor to Call</option> */}
                                    <option value="Completed">Completed</option>
                                </TextField>
                            </td>
                            {/* <td>
                                <ICInput
                                    name={"pharmacistName" + index}
                                    className="ml-2 search-columns-input"
                                    type="text"
                                    value={item.pharmacistName ? item.pharmacistName : ''}
                                    onChange={e => handlePharmacistChangeInput(e.target.value, index)}
                                />
                            </td> */}
                            <td>
                                <ICInput
                                    name={"notes" + index}
                                    multiline
                                    className="ml-2 search-columns-input"
                                    type="text"
                                    value={item.notes ? item.notes : ''}
                                    onChange={e => handleNoteChangeInput(e.target.value, index)}
                                />
                            </td>
                            <td>
                                <button
                                    onClick={e => {
                                        e.stopPropagation();
                                        redoEPrescription(item, index);
                                    }}
                                    type="button"
                                    className="btn btn-out-black high-z-index mb-2"
                                >
                                    <i className="fas fa-redo-alt"></i>
                                </button>
                                <br />
                                <button
                                    onClick={e => {
                                        e.stopPropagation();
                                        saveDetails(item);
                                    }}
                                    type="button"
                                    className="btn btn-out-green high-z-index"
                                >
                                    <i className="fas fa-save"></i>
                                </button>
                                <br />
                                <button
                                    onClick={e => {
                                        e.stopPropagation();
                                        openConfirmDeletPopUp(item);
                                    }}
                                    type="button"
                                    className="btn btn-out-delete high-z-index mt-2"
                                >
                                    <i className="fas fa-trash-alt"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </CustomDataTable>

                <CustomModal
                    openModal={showDeletePopup}
                    cancelEvent={() => {
                        setShowDeletePopup(false);
                        setSelectedConsultNote(null);
                    }}
                    cancelText="No"
                    okayEvent={deleteTraditionalPrescription}
                    okayText="Yes"
                    title=""
                    modalBodyContent={
                        <p className="text-center">Are you sure you want to delete this task?</p>
                    }

                />
                {/* API Call */}
                <MakeAPICall apiParam={apiCallParams} />
            </div>
        </div>
    );
};

// export default TraditionalPrescriptionListPage;
const mapStateToProps = state => ({
    auth: state.auth,
    serverConstants: state.serverConstants
});

const mapDispatchToProps = dispatch => ({
    updateUnreadErxOfflineCount: data => dispatch(updateUnreadErxOfflineCount(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TraditionalPrescriptionListPage);
